import { useState, useEffect, useCallback } from "react";

export function useCollapse(initiallyCollapsed: boolean | (() => boolean) = false) {
  const [isExpanded, setIsExpanded] = useState(
    !(typeof initiallyCollapsed === "function" ? initiallyCollapsed() : initiallyCollapsed),
  ); // used for the component's expanded state.
  const [isTriggered, setIsTriggered] = useState(isExpanded); // Used for starting the animation/transition in the component.

  const expand = useCallback(() => setIsTriggered(true), []);
  const collapse = useCallback(() => setIsTriggered(false), []);

  useEffect(() => {
    const timer = setTimeout(() => setIsExpanded(isTriggered), 100); // sync with width animation/transition in the component.
    return () => clearTimeout(timer);
  }, [isTriggered]);

  return {
    isExpanded,
    isTriggered,
    expand,
    collapse,
  };
}
